import { AdminField } from './AdminField';

interface Props {
  note: string;
  onChangeNote(s: string): void;
  onCancel(): void;
  onConfirm(): void;
}

export function AdminPublishModal({ note, onChangeNote, onCancel, onConfirm }: Props) {
  return (
    <div className="adm-modal-bg" role="dialog" aria-modal="true" aria-labelledby="adm-publish-title">
      <div className="adm-modal">
        <h3 id="adm-publish-title">Publish current draft?</h3>
        <p>
          This pushes your current draft to a new published version. The public tool
          loads the latest published config on next page load.
        </p>
        <AdminField label="Publish note (optional, max 200 chars)">
          <input
            className="adm-input"
            type="text"
            maxLength={200}
            value={note}
            onChange={(e) => onChangeNote(e.target.value)}
            placeholder="e.g. Q2 calc tune-up"
          />
        </AdminField>
        <div className="adm-modal__actions">
          <button className="adm-btn adm-btn--ghost" type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className="adm-btn adm-btn--primary" type="button" onClick={onConfirm}>
            Publish
          </button>
        </div>
      </div>
    </div>
  );
}
